import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHelmet from '@/components/feature/SeoHelmet';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '丫丫漫画',
    url: typeof window !== 'undefined' ? `${window.location.origin}${__BASE_PATH__}` : '',
    description: '丫丫漫画平台韩漫、日漫、国漫热门分类，免费全集下拉式阅读，好看的漫画一网打尽，追更收藏随时看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: typeof window !== 'undefined' ? `${window.location.origin}${__BASE_PATH__}/category/korean?q={search_term_string}` : '',
      },
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '丫丫漫画',
    url: typeof window !== 'undefined' ? `${window.location.origin}${__BASE_PATH__}` : '',
    description: '免费在线漫画阅读平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@yaya-comic.com',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '丫丫漫画 - 首页',
    description: '丫丫漫画平台韩漫、日漫、国漫热门分类，免费全集下拉式阅读，好看的漫画一网打尽。',
    isPartOf: {
      '@type': 'WebSite',
      name: '丫丫漫画',
    },
    inLanguage: 'zh-CN',
  },
];

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SeoHelmet
        title="丫丫漫画 | 丫丫漫画韩漫与丫丫漫画日漫 | 丫丫漫画国漫热门分类大全"
        description="丫丫漫画平台韩漫、日漫、国漫热门分类，免费全集下拉式阅读，好看的漫画一网打尽，追更收藏随时看。"
        keywords="丫丫漫画韩漫,丫丫漫画日漫,丫丫漫画国漫,丫丫漫画热门漫画,丫丫漫画,免费漫画,全集,下拉式,在线阅读,好看的漫画"
        ogType="website"
        canonicalPath="/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedComics />
        <LatestUpdates />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}